document.addEventListener('DOMContentLoaded', function() {
  const btn = document.getElementById('find-in-store-btn');
  const modal = document.getElementById('find-in-store-modal');
  const variantDataScript = document.getElementById('product-variants-json');

  if (!btn || !modal || !variantDataScript) {
    return;
  }

    function disableBodyScroll() {
    // Calculate the width of the scrollbar
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    // Add padding to the body to avoid content shift
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    // Add the class to hide the overflow
    document.body.classList.add('modal-open-no-scroll');
  }

  function enableBodyScroll() {
    // Remove the class to restore overflow
    document.body.classList.remove('modal-open-no-scroll');
    // Remove the inline padding
    document.body.style.paddingRight = '';
  }

  let isGoogleMapsApiLoaded = false

   // Main application state 
  const state = {
    shopDomain: modal.dataset.shopDomain,
    allVariants: JSON.parse(variantDataScript.textContent),
    productOptions: [],
    selectedOptions: [], 
    currentSku: null,
    lastSearchType: 'all',
    lastLocation: null,
    autocomplete: null
  };

  const elements = {
    closeBtn: modal.querySelector('.find-in-store-close'),
    resultsContainer: document.getElementById('find-in-store-results'),
    variantSelectorContainer: document.getElementById('fis-variant-selector-container')
  };
  
  const infoIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>`;
  const preloaderSvg = `<svg class="preloader-spinner" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>`;

  // --- Variant Picker Logic ---

  function initVariantSelector() {
    state.productOptions = state.allVariants[0].options.map(opt => (typeof opt === 'string' ? opt : opt.name));
    elements.variantSelectorContainer.innerHTML = '';
    const initialVariant = getVariantFromPage() || state.allVariants.find(v => v.available);

    // ✅ Initialize our "source of truth" array with the starting variant's options
    if (initialVariant) {
      state.selectedOptions = [...initialVariant.options];
    }

    state.productOptions.forEach((optionName, index) => {
      const optionValues = [...new Set(state.allVariants.map(v => v.options[index]))];
      
      if (optionValues.length > 1) { // Only render if there's a choice to be made
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'fis-variant-pills product-form__input';
        fieldset.dataset.index = index; // Store the true option index

        let variantTitle = optionName;
        if (index === 0) variantTitle = "SELECT COLOUR";
        else if (index === 1) variantTitle = "SELECT SIZE";
        
        const legend = document.createElement('legend');
        legend.className = 'form__label';
        legend.textContent = variantTitle;
        fieldset.appendChild(legend);

        optionValues.forEach(value => {
          const inputId = `fis-option-${index}-${value.replace(/\s+/g, '-')}`;
          const input = document.createElement('input');
          input.type = 'radio';
          input.id = inputId;
          input.name = `fis-option-${index}`;
          input.value = value;
          
          if (state.selectedOptions[index] === value) {
            input.checked = true;
          }
          
          const label = document.createElement('label');
          label.htmlFor = inputId;
          label.textContent = value;
          
          fieldset.appendChild(input);
          fieldset.appendChild(label);
        });
        elements.variantSelectorContainer.appendChild(fieldset);
      }
    });

    updateVariantAvailability();
    updateCurrentSkuFromState();
    elements.variantSelectorContainer.addEventListener('change', onVariantChange);
  }

  function getVariantFromPage() {
    const variantInput = document.querySelector('input[name="id"], .product-variant-id');
    if (!variantInput) return null;
    return state.allVariants.find(v => v.id == variantInput.value);
  }
  
  function updateCurrentSkuFromState() {
    const foundVariant = state.allVariants.find(variant => 
      variant.options.every((opt, index) => opt === state.selectedOptions[index])
    );
    state.currentSku = foundVariant ? foundVariant.sku : null;
    return !!foundVariant;
  }
  
  function updateVariantAvailability() {
    const fieldsets = elements.variantSelectorContainer.querySelectorAll('fieldset');
    fieldsets.forEach(fieldset => {
      const index = parseInt(fieldset.dataset.index, 10);
      const inputs = fieldset.querySelectorAll('input[type="radio"]');

      inputs.forEach(input => {
        const tempOptions = [...state.selectedOptions];
        tempOptions[index] = input.value;

        const isAvailable = state.allVariants.some(variant => 
          variant.options.every((opt, i) => tempOptions[i] === null || opt === tempOptions[i])
        );
        input.disabled = !isAvailable;
      });
    });
  }

  function onVariantChange(event) {
    const fieldset = event.target.closest('fieldset');
    if (!fieldset) return;

    const index = parseInt(fieldset.dataset.index, 10);
    const value = event.target.value;
    state.selectedOptions[index] = value;

    updateVariantAvailability();
    if (updateCurrentSkuFromState()) {
      if (state.lastSearchType === 'location' && state.lastLocation) {
        findStoresByLocation(state.lastLocation);
      } else {
        findAllStores();
      }
    } else {
      showResults(`<div class="notice-box info">${infoIconSvg}<span>This combination is not available.</span></div>`);
    }
  }
  // --- API and Rendering Logic ---

  function runSearch() {
    const sku = state.currentSku;
    if (!sku) {
      showResults(`<div class="notice-box info">${infoIconSvg}<span>This product variant does not have a SKU.</span></div>`);
      return;
    }

    const isLocationSearch = state.lastSearchType === 'location' && state.lastLocation;
    const body = { sku, shop: state.shopDomain };
    if (isLocationSearch) {
      body.location = state.lastLocation;
    }

    fetch('https://speciality-find-in-store-eb870379a457.herokuapp.com/api/find-in-store', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(data => {
      if (data.stores && data.stores.length > 0) {
        if (isLocationSearch) data.stores.sort((a, b) => a.distance - b.distance);
        else data.stores.sort((a, b) => a.store.name.localeCompare(b.store.name));
        renderStoreList(data.stores, isLocationSearch);
      } else {
        const message = isLocationSearch 
          ? `This product is not currently available in stores near the selected location.`
          : `This product is not currently available in any of our stores.`;
        showResults(`<div class="notice-box info">${infoIconSvg}<span>${message}</span></div>`);
      }
    })
    .catch(err => handleError(err));
  }

  function findAllStores() {
    state.lastSearchType = 'all';
    state.lastLocation = null;
    showResults(`<div class="notice-box info">${preloaderSvg}<span>Finding all available stores...</span></div>`);
    runSearch();
  }

  function findStoresByLocation(location) {
    state.lastSearchType = 'location';
    state.lastLocation = location;
    showResults(`<div class="notice-box info">${preloaderSvg}<span>Searching for stock near you...</span></div>`);
    runSearch();
  }

  function renderStoreList(stores, showDistance) {
    let listHtml = '<ul class="store-list">';
    stores.forEach((storeData, index) => {
      const { store, distance, quantity } = storeData;
      const storeId = store.name.replace(/[^a-zA-Z0-9]/g, '') + index;
      const distanceHtml = showDistance ? `<small>(${distance.toFixed(1)} km away)</small>` : '';
      const isLowStock = quantity <= 2;
      const availabilityMessage = isLowStock ? "Available for in-store purchase with low stock" : "Available for in-store purchase";
      const availabilityClass = isLowStock ? "low-stock" : "";

      listHtml += `
        <li class="store-list-item" id="store-item-${storeId}">
          <div class="store-summary">
            <div>
              <h4>${store.name} ${distanceHtml}</h4>
              <p>${store.address || 'Address not available'}</p>
              <p class="store-availability ${availabilityClass}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                <span>${availabilityMessage}</span>
              </p>
            </div>
            <button class="store-details-toggle button button--tertiary" data-target="${storeId}">See More</button>
          </div>
          <div class="store-details-collapsible">
            <div class="store-details-map" id="map-for-${storeId}" data-lat="${store.latitude}" data-lng="${store.longitude}" data-name="${store.name}"></div>
            <div class="store-actions-grid">
              <a href="${store.google_maps_url || '#'}" target="_blank" rel="noopener noreferrer" class="button button--primary">Directions</a>
              <a href="tel:${store.contact_number || ''}" class="store-contact-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <span>${store.contact_number || 'No Number'}</span>
              </a>
            </div>
            <h4 class="operating-hours-title">Opening Hours</h4>
            <div class="operating-hours-grid">${formatOperatingHours(store.operating_hours)}</div>
          </div>
        </li>`;
    });
    listHtml += '</ul>';
    showResults(listHtml);
  }

  function handleError(err) { 
    console.error('Error searching:', err);
    showResults(`<div class="notice-box info">${infoIconSvg}<span>Sorry, an error occurred. Please try again.</span></div>`);
  }
  function showResults(html) { 
    elements.resultsContainer.innerHTML = html;
  }
  function formatOperatingHours(hours) { 
    if (!hours) return '<div>Hours not available.</div>';
    const daysOrder = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
    const formatTime = (timeStr) => (typeof timeStr === 'string' && timeStr.includes(':') ? timeStr.slice(0, 5) : '');
    const groupedHours = [];
    let currentGroup = null;
    daysOrder.forEach(day => {
      const dayHours = hours[day];
      let timeRange = "Closed";
      if (dayHours) {
        if (dayHours.all_day) timeRange = "24 Hours";
        else if (dayHours.open && dayHours.close) {
          const openTime = formatTime(dayHours.open);
          const closeTime = formatTime(dayHours.close);
          if (openTime && closeTime) timeRange = `${openTime} - ${closeTime}`;
        }
      }
      if (!currentGroup || currentGroup.timeRange !== timeRange) {
        if (currentGroup) groupedHours.push(currentGroup);
        currentGroup = { days: [day], timeRange: timeRange };
      } else {
        currentGroup.days.push(day);
      }
    });
    if (currentGroup) groupedHours.push(currentGroup);
    const formatDayRange = (days) => {
      const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
      if (days.length === 1) return capitalize(days[0]);
      return `${capitalize(days[0])} - ${capitalize(days[days.length - 1])}`;
    };
    let html = '';
    groupedHours.forEach(group => {
      html += `<div>${formatDayRange(group.days)}</div> <div>${group.timeRange}</div>`;
    });
    return html || '<div>Hours not available.</div>';
  }

  function loadGoogleMapsApi(callback) {
    // If the 'google' object exists, the API is already loaded.
    if (typeof google !== 'undefined' && google.maps) {
      isGoogleMapsApiLoaded = true;
      if (callback) callback();
      return;
    }
    
    // If we've already tried to load it, don't do it again.
    if (window.googleMapsApiLoading) return;
    
    window.googleMapsApiLoading = true;
    const mapsApiUrl = modal.dataset.mapsApiUrl;
    
    if (!mapsApiUrl) {
      console.error('Maps API URL is not defined in data-maps-api-url attribute.');
      window.googleMapsApiLoading = false;
      return;
    }

    const script = document.createElement('script');
    script.src = mapsApiUrl;
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      isGoogleMapsApiLoaded = true;
      window.googleMapsApiLoading = false;
      if (callback) callback();
    };

    script.onerror = () => {
      console.error("Failed to load the Google Maps API script.");
      window.googleMapsApiLoading = false;
      // You could show an error message in the modal here
    };

    document.head.appendChild(script);
  }

  function initMapForStore(mapElement) { 
    if (typeof google === 'undefined' || mapElement.dataset.mapInitialized === 'true') return;
    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);
    const name = mapElement.dataset.name;

     const mapStyles = [
        { elementType: "geometry", stylers: [{ color: "#3c3c3c" }] }, // Lighter grey background
        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#b0b0b0" }] }, // Brighter text for contrast
        { elementType: "labels.text.stroke", stylers: [{ color: "#3c3c3c" }] },
        { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }, { visibility: "off" }] },
        { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
        { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
        { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#2c2c2c" }] }, // Darker parks
        { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#212121" }] }, // Dark roads
        { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#2c2c2c" }] },
        { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#2c2c2c" }] },
        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#1a1a1a" }] }, // Even darker highways
        { featureType: "transit", stylers: [{ visibility: "off" }] },
        { featureType: "water", elementType: "geometry", stylers: [{ color: "#111111" }] }, // Almost black water
        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] },
      ];
    const map = new google.maps.Map(mapElement, {
      center: { lat, lng }, zoom: 15, disableDefaultUI: true, zoomControl: true,
      styles: mapStyles
    });
    const icon = {
        url: "https://cdn.shopify.com/s/files/1/0987/0940/files/base-locate.png",
        scaledSize: new google.maps.Size(35, 40),
        anchor: new google.maps.Point(17, 40)
      };
    new google.maps.Marker({
      position: { lat, lng }, map: map, title: name, icon: icon,
    });
    mapElement.dataset.mapInitialized = 'true';
  }


  // --- Event Listeners ---

  btn.onclick = () => {
    modal.style.display = 'block';
    disableBodyScroll()
    initVariantSelector(); // Initialize the variant selectors
    findAllStores(); // Run the initial search for the selected variant
    setTimeout(initAutocomplete, 100);
    loadGoogleMapsApi(initAutocomplete)
  };

  elements.closeBtn.onclick = () => { 
    modal.style.display = 'none';
    enableBodyScroll() 
  };
  window.onclick = (e) => { 
    if (e.target == modal) { 
      modal.style.display = 'none'; 
      enableBodyScroll()
    } 
  };
  
  elements.resultsContainer.addEventListener('click', function(e) {
    const toggleButton = e.target.closest('.store-details-toggle');
    if (toggleButton) {
      const storeId = toggleButton.dataset.target;
      const targetItem = document.getElementById(`store-item-${storeId}`);
      if (!targetItem) return;
      const isActive = targetItem.classList.contains('active');
      document.querySelectorAll('.store-list-item.active').forEach(item => {
        if (item !== targetItem) {
            item.classList.remove('active');
            const otherButton = item.querySelector('.store-details-toggle');
            if (otherButton) otherButton.textContent = 'See More';
        }
      });
      targetItem.classList.toggle('active');
      toggleButton.textContent = isActive ? 'See More' : 'See Less';
      if (!isActive) {
        const mapElement = targetItem.querySelector('.store-details-map');
        initMapForStore(mapElement);
      }
    }
  });

  document.getElementById('use-my-location-btn').onclick = () => {
    showResults(`<div class="notice-box info">${preloaderSvg}<span>Finding your location...</span></div>`);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => findStoresByLocation({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
        () => showResults(`<div class="notice-box info">${infoIconSvg}<span>Could not get your location. Please check browser permissions and try again.</span></div>`)
      );
    } else {
      showResults(`<div class="notice-box info">${infoIconSvg}<span>Geolocation is not supported by your browser.</span></div>`);
    }
  };

  document.getElementById('search-address-btn').onclick = () => {
    const address = document.getElementById('address-input').value;
    if (address) findStoresByLocation(address);
  };

  document.getElementById('address-input').addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      findStoresByLocation(this.value);
    }
  });
  
  function initAutocomplete() {
    if (typeof google === 'undefined' || state.autocomplete) return;
    const input = document.getElementById('address-input');
    const options = { types: ['geocode'], componentRestrictions: { country: 'ZA' } };
    state.autocomplete = new google.maps.places.Autocomplete(input, options);
    state.autocomplete.addListener('place_changed', () => {
      const place = state.autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        const location = { latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng() };
        findStoresByLocation(location);
      }
    });
  }
});